import { render, staticRenderFns } from "./EditQuote.vue?vue&type=template&id=4c0564ae&scoped=true"
import script from "./EditQuote.vue?vue&type=script&lang=js"
export * from "./EditQuote.vue?vue&type=script&lang=js"
import style0 from "./EditQuote.vue?vue&type=style&index=0&id=4c0564ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0564ae",
  null
  
)

export default component.exports